// API client for /api/broadcasts (superadmin endpoints).
import { apiFetch } from "../../context/AuthContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const ROOT = `${BASE_URL}/api/broadcasts`;

async function call(path, { method = "GET", body } = {}) {
  const res = await apiFetch(`${ROOT}${path}`, {
    method,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  let json = null;
  try {
    json = await res.json();
  } catch {
    /* empty body */
  }
  if (!res.ok || json?.success === false) {
    const msg = json?.error || json?.message || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.details = json?.details;
    throw err;
  }
  return json?.data;
}

const qs = (params) => {
  const s = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") s.set(k, String(v));
  });
  const str = s.toString();
  return str ? `?${str}` : "";
};

export const broadcastApi = {
  // templates & presets
  listTemplates: () => call("/templates"),
  createTemplate: (body) => call("/templates", { method: "POST", body }),
  updateTemplate: (id, body) => call(`/templates/${id}`, { method: "PUT", body }),
  deleteTemplate: (id) => call(`/templates/${id}`, { method: "DELETE" }),
  duplicateTemplate: (id) => call(`/templates/${id}/duplicate`, { method: "POST" }),

  // audiences
  listAudiences: () => call("/audiences"),
  createAudience: (body) => call("/audiences", { method: "POST", body }),
  updateAudience: (id, body) => call(`/audiences/${id}`, { method: "PUT", body }),
  deleteAudience: (id) => call(`/audiences/${id}`, { method: "DELETE" }),
  previewAudience: (body) => call("/audience-preview", { method: "POST", body }),

  // picker data
  targetOptions: () => call("/target-options"),
  searchUsers: (q) => call(`/target-options/users${qs({ q })}`),

  // broadcasts
  list: (params) => call(`/${qs(params)}`),
  get: (id) => call(`/${id}`),
  recipients: (id, params) => call(`/${id}/recipients${qs(params)}`),
  create: (body) => call("/", { method: "POST", body }),
  update: (id, body) => call(`/${id}`, { method: "PUT", body }),
  send: (id) => call(`/${id}/send`, { method: "POST" }),
  cancel: (id) => call(`/${id}/cancel`, { method: "POST" }),
  remove: (id) => call(`/${id}`, { method: "DELETE" }),
};
